<template>
  <v-card elevation="0" tile :color="bg_color" class="mx-5">
    <v-container class="py-0">
      <v-row justify="center">
        <v-card elevation="0" tile class="px-0" width="1200" :color="bg_color">
          <v-fab-transition>
            <v-btn
              :color="theme_color"
              dark
              absolute
              top
              left
              fab
              :x-large="!isSmall"
            >
              <v-icon color="white">{{ main_icon }}</v-icon>
            </v-btn>
          </v-fab-transition>
          <v-card-text>
            <v-list class="mb-10" :color="bg_color">
              <v-subheader class="px-0 mx-0 mt-5">
                <v-row justify="center" class="px-0 mx-0">
                  <v-col cols="4">
                    <span
                      :class="
                        isSmall
                          ? theme_text_color + ' subtitle-1'
                          : theme_text_color + ' title'
                      "
                    >
                      Teaching
                    </span>
                  </v-col>
                  <v-spacer></v-spacer>

                  <v-col cols="4">
                    <span class="subtitle-1"> Institute </span></v-col
                  >
                  <v-col cols="4">
                    <span class="subtitle-1"> Semester </span></v-col
                  >
                </v-row></v-subheader
              >
              <v-list-item-group active-class="border" :color="theme_color">
                <v-list-item
                  v-for="(item, index) of teaching"
                  :key="index"
                  class="pa-0"
                >
                  <v-row justify="center" class="px-0 mx-0 py-4">
                    <v-col cols="4" align-self="center">
                      <span class="subtitle-1">{{ item.course }}</span>
                    </v-col>
                    <v-col cols="4" align-self="center">
                      <span class="subtitle-1 font-weight-light">{{
                        item.institute
                      }}</span>
                    </v-col>
                    <v-col cols="4" align-self="center">
                      <span class="subtitle-1 font-weight-light">
                        {{ item.semester }}</span
                      >
                    </v-col>
                  </v-row>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card-text>
        </v-card>
      </v-row>
      <v-divider></v-divider>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "education",
  created() {
    window.addEventListener("resize", this.cal_window);
  },
  destroyed() {
    window.removeEventListener("resize", this.cal_window);
  },
  mounted() {
    this.cal_window();
  },
  methods: {
    cal_window() {
      this.isSmall = window.innerWidth < 1264 ? true : false;
    },
  },
  data: () => ({
    main_icon: "mdi-forum",
    bg_color: "grey lighten-5",
    theme_color: "indigo darken-1",
    theme_text_color: "indigo--text text--darken-1",
    isSmall: false,
    teaching: [
      {
        course: "Chemo Dynamic (CE 584)",
        semester: "Fall 2017 - Fall 2018",
        institute: "Clarkson University",
      },
    ],
  }),
};
</script>
<style scoped>
/* div {
  outline: 1px dashed blue;
} */
</style>

